// Utility function to strip HTML tags from rich text content
export const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

// Get truncated plain text from HTML
export const getPlainTextPreview = (html, maxLength = 150) => {
  const plainText = stripHtml(html);
  if (plainText.length <= maxLength) return plainText;
  return plainText.substring(0, maxLength) + '...';
};

// Format date string without timezone issues
// Handles both ISO strings (2025-02-04T00:00:00Z) and date-only strings (2025-02-04)
export const formatDateSafe = (dateString) => {
  if (!dateString) return '';
  
  // If it's a date-only string (YYYY-MM-DD), parse it directly
  if (dateString.length === 10 && dateString.includes('-')) {
    const [year, month, day] = dateString.split('-');
    return new Date(year, month - 1, day).toLocaleDateString();
  }
  
  // For ISO strings, extract the date part and parse without timezone conversion
  const datePart = dateString.split('T')[0];
  if (datePart && datePart.includes('-')) {
    const [year, month, day] = datePart.split('-');
    return new Date(year, month - 1, day).toLocaleDateString();
  }
  
  // Fallback for other formats
  return new Date(dateString).toLocaleDateString();
};

// Check if a deadline is overdue (comparing date parts only)
export const isDeadlineOverdue = (dateString) => {
  if (!dateString) return false;
  
  const datePart = dateString.split('T')[0];
  const [year, month, day] = datePart.split('-');
  const deadlineDate = new Date(year, month - 1, day);
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  return deadlineDate < today;
};
